import { ref } from "vue";

// Contextul utilizatorului curent expus global pentru shell (navbar + Home):
// numele companiei (angajatorul, în stilul „workspace name" din Slack/Linear/Notion)
// și numele afișat al persoanei pentru salut. Sursa de adevăr este endpoint-ul
// `/me` (`company_name`, `name`); valorile se persistă pentru afișare imediată
// după refresh.
const COMPANY_KEY = "user-company-name";
const USER_NAME_KEY = "user-display-name";

const readStored = (key) => {
  try {
    return globalThis?.localStorage?.getItem(key) || "";
  } catch (_) {
    return "";
  }
};

const writeStored = (key, value) => {
  try {
    if (value) {
      globalThis?.localStorage?.setItem(key, value);
    } else {
      globalThis?.localStorage?.removeItem(key);
    }
  } catch (_) {
    /* ignore storage issues */
  }
};

const companyName = ref(readStored(COMPANY_KEY));
const userName = ref(readStored(USER_NAME_KEY));

export const setCurrentCompanyName = (name) => {
  const value = (name ?? "").toString().trim();
  companyName.value = value;
  writeStored(COMPANY_KEY, value);
};

export const setCurrentUserName = (name) => {
  const value = (name ?? "").toString().trim();
  userName.value = value;
  writeStored(USER_NAME_KEY, value);
};

export const clearCurrentCompanyName = () => setCurrentCompanyName("");
export const clearCurrentUserName = () => setCurrentUserName("");

export const useCurrentCompany = () => ({ companyName, userName });
